import "../App.css";
import React, { useState, useEffect } from "react";
//import { useParams, Link } from "react-router-dom";
//import { call, home } from "../service/ApiService";
import { call, signout } from "../service/ApiService";
import {
  //Container,
  //List,
  //Paper,
  Grid,
  Button,
  AppBar,
  Toolbar,
  Typography,
} from "@mui/material";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { lime, purple } from "@mui/material/colors";

import secureLocalStorage from "react-secure-storage";

export function NavigationBarLogin(subject) {
  const [userName, setUserName] = useState("");
  const [loginMark, setLoginMark] = useState(0);

  useEffect(() => {
    //effect 훅 //랜더링 후에 수행 이후  []의 오브젝트가 변경되면 수행
    // 로컬 스토리지에서 USER_TOKEN 가져오기
    const userToken = secureLocalStorage.getItem("USER_TOKEN");
    //const userToken = localStorage.getItem("USER_TOKEN");
    //const userToken = sessionStorage.getItem("USER_TOKEN");
    //let userName = "";
    if (userToken && userToken !== null) {
      //userName = userToken;
      setUserName(userToken);
      setLoginMark(1);
    } else {
      setUserName("");
      setLoginMark(0);
    }
  }, []);

  function goHome() {
    return (window.location.href = "/home");
  }
  function goLogin() {
    return (window.location.href = "/login");
  }

  const theme = createTheme({
    palette: {
      primary: lime,
      secondary: purple,
    },
  });

  let loginGrid;
  if (loginMark === 0) {
    loginGrid = (
      <ThemeProvider theme={theme}>
        <Grid item>
          <Button color="primary" onClick={goLogin}>
            {"["}로그인하기 {"]"}
          </Button>
        </Grid>
      </ThemeProvider>
    );
  } else {
    loginGrid = (
      <Grid item>
        <Button color="inherit" onClick={signout}>
          {"["}
          {userName}
          {"]"} 로그아웃
        </Button>
      </Grid>
    );
  }

  return (
    <AppBar position="static" color="primary">
      <Toolbar>
        <Grid justifyContent="space-between" container>
          <Grid item>
            <Button color="inherit" onClick={goHome}>
              <Typography variant="h9">{"go to home"}</Typography>
            </Button>
          </Grid>

          <Grid item>
            <span></span>
            {/* <Typography variant="h5">{subject}</Typography>*/}
          </Grid>
          <span></span>
          {/*loginGrid*/}
        </Grid>
      </Toolbar>
    </AppBar>
  );
}
